import type { PropType } from 'virtual-vue';
import type { CheckboxTheme } from './checkbox';

/**
 * checkbox组件的props
 * 基于方案设计文档生成
 */
export const checkboxProps = {
  /**
   * 是否选中（Vue2）。支持语法糖 v-model
   * @default false
   */
  value: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否选中（Vue3）。支持语法糖 v-model
   * @default false
   */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否为禁用态
   */
  disabled: Boolean,
  /**
   * 多选按钮的值（用于checkbox-group）
   */
  checkboxValue: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
  },
  /**
   * 主文案
   */
  label: String,
  /**
   * 描述文案
   */
  desc: String,
  /**
   * 主题，用于浅色背景或深色背景
   * @default 'light'
   */
  theme: {
    type: String as PropType<CheckboxTheme>,
    default: 'light',
  },
};

